import React from "react";

import EditorUtilsProvider from "./editorUtils";
import { OverlayProvider } from "./OverlayProvider";
import UuidProvider from "./uuid";

/**
 * @description 프로젝트 전역에서 사용되는 Context를 모아서 관리합니다.
 * @caution ContextProvider는 반드시 AuthGuard 상위에 위치해야 합니다.
 */
function ContextProvider({ children }: { children: React.ReactNode }) {
  return (
    <UuidProvider>
      <OverlayProvider>
        <EditorUtilsProvider>{children}</EditorUtilsProvider>
      </OverlayProvider>
    </UuidProvider>
  );
}

export default ContextProvider;
